import { combineLatest, Subscription } from "rxjs";
import Logger from '../../js/lib/logger';
import { addInsert$, depth$, modal$, width$ } from "../lib/state";
import { InsertConfigData } from "../lib/types";
import { createDimensionalOptions, generateInsertId } from "../lib/util.functions";

class CustomInsertModal extends HTMLElement {
  #NAME = 'CustomInsertModal'
  #abortController: AbortController | null = null
  #form: HTMLFormElement
  #widthSelect: HTMLSelectElement;
  #heightSelect: HTMLSelectElement;
  #titleInput: HTMLInputElement;
  #sub?: Subscription

  constructor() {
    super();
    Logger.info(`${this.#NAME} > constructor`);
    this.#form = this.querySelector('form') as HTMLFormElement;
    this.#widthSelect = this.querySelector('select[name="unitWidth"]') as HTMLSelectElement;
    this.#heightSelect = this.querySelector('select[name="unitHeight"]') as HTMLSelectElement;
    this.#titleInput = this.querySelector('input[name="title"]') as HTMLInputElement;
  }

  connectedCallback(): void {
    Logger.info(`${this.#NAME} > connectedCallback`);
    this.#abortController = new AbortController();
    const { signal } = this.#abortController;
    //
    this.#form.addEventListener('submit', (e) => this.#onSubmit(e), { signal });
    //
    this.#sub = combineLatest({
      width: width$,
      depth: depth$,
    }).subscribe(({ width, depth }) => {
      this.#widthSelect.append(...createDimensionalOptions('insert-width', 'whole')
                                .filter(option => parseFloat(option.value) <= width)
                                .map(option => {
                                  option.textContent = `${option.textContent.split('.')[0]}”`; 
                                  return option;
                                })
                              );
      this.#heightSelect.append(...createDimensionalOptions('insert-depth', 'whole')
                                .filter(option => parseFloat(option.value) <= depth)
                                .map(option => {
                                  option.textContent = `${option.textContent.split('.')[0]}”`; 
                                  return option;
                                })
                              );
    });
  }

  disconnectedCallback(): void {
    Logger.info(`${this.#NAME} > disconnectedCallback`);
    this.#abortController?.abort();
    this.#abortController = null;
    this.#sub?.unsubscribe();
  }

  #onSubmit(e: SubmitEvent) {
    e.preventDefault();
    const configData: InsertConfigData = {
      type: 'custom',
      id: generateInsertId(),
      unitWidth: parseFloat(this.#widthSelect.value),
      unitHeight: parseFloat(this.#heightSelect.value),
      x: 0,
      y: 0,
      title: this.#titleInput.value.length ? this.#titleInput.value : undefined
    };
    Logger.info(`${this.#NAME} > #onSubmit >`, configData);
    addInsert$.next(configData);
    modal$.next({ show: false });
    setTimeout(() => {
      this.#form.reset();
    }, 500);
  }
}

customElements.define('custom-insert-modal', CustomInsertModal);